import { defineStore } from 'pinia'
import { useMqttStore } from '@/store/mqttStore'
import { antDevice, bleDevice, deviceType } from '@/types/device'
import { MqttTopic } from '@/mqttDefinitions'

export const useDeviceStore = defineStore('deviceStore', {
  state: (): {
    antDevices: Array<antDevice>
    bleDevices: Array<bleDevice>
    motorStatus: {
      error: boolean
      overcurrent: boolean
      stalled: boolean
      hasHadHighTemperature?: boolean
      highTemperature: boolean
      handleBar: {
        x: {
          overcurrent: boolean
          stalled: boolean
          limitSwitch: boolean
        }
        y: {
          overcurrent: boolean
          stalled: boolean
          limitSwitch: boolean
        }
      }
      saddle: {
        x: {
          overcurrent: boolean
          stalled: boolean
          limitSwitch: boolean
        }
        y: {
          overcurrent: boolean
          stalled: boolean
          limitSwitch: boolean
        }
      }
    }
    heartRateStatus: {
      connected: boolean
      connecting: boolean
    }
    resistanceWheelStatus: {
      connected: boolean
      connecting: boolean
    }
    xyToolStatus: {
      connected: boolean
      connecting: boolean
    }
  } => ({
    antDevices: [],
    bleDevices: [],
    motorStatus: {
      error: false,
      overcurrent: false,
      stalled: false,
      hasHadHighTemperature: false,
      highTemperature: false,
      handleBar: {
        x: {
          overcurrent: false,
          stalled: false,
          limitSwitch: false,
        },
        y: {
          overcurrent: false,
          stalled: false,
          limitSwitch: false,
        },
      },
      saddle: {
        x: {
          overcurrent: false,
          stalled: false,
          limitSwitch: false,
        },
        y: {
          overcurrent: false,
          stalled: false,
          limitSwitch: false,
        },
      },
    },
    heartRateStatus: {
      connected: false,
      connecting: false,
    },
    resistanceWheelStatus: {
      connected: false,
      connecting: false,
    },
    xyToolStatus: {
      connected: false,
      connecting: false,
    },
  }),
  getters: {
    getAntDevicesByType:
      (state) =>
      (deviceType: deviceType): Array<antDevice> => {
        return state.antDevices?.filter((x) => x.type === deviceType) ?? []
      },
    getBleDevicesByType:
      (state) =>
      (deviceType: deviceType): Array<bleDevice> => {
        return state.bleDevices?.filter((x) => x.type === deviceType) ?? []
      },
  },
  actions: {
    updateAntList(antDevices: Array<antDevice>) {
      this.antDevices = antDevices
    },
    updateBleList(bleDevices: Array<bleDevice>) {
      this.bleDevices = bleDevices
    },
    doDevicesRefresh() {
      const mqttStore = useMqttStore()
      const { doRawPublish, client } = mqttStore

      doRawPublish(
        MqttTopic.CONTROLLER_DEVICES_REFRESH,
        JSON.stringify({}),
        client,
      )
    },
  },
})
